import { BaseDataTransferObject } from '../base-data-transfer-object';

export class Physician extends BaseDataTransferObject {
    public firstName!: string;
    public lastName!: string;
    public npi!: string;
}

